import { configure as configureWidget } from 'instantsearch.js/es/widgets'

export let configure
const wrapper = document.querySelector('[data-products]')

function json(str) {
  try {
    JSON.parse(str)
    return JSON.parse(str)
  } catch (e) {
    return {}
  }
}

if (wrapper !== null && typeof wrapper !== 'undefined') {
  const filters = wrapper.dataset.filter ?? {}
  const filtersObject = json(filters)

  configure = configureWidget({
    hitsPerPage: 50,
    distinct: true,
    facetingAfterDistinct: true,
    disjunctiveFacetsRefinements: filtersObject,
  })
}
